import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import TenantManagement from './components/TenantManagement';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <TenantManagement />
      </div>
    </Provider>
  );
}

export default App;